<template>
    <div>
        <b-button variant="light" @click="show = true"> Vars </b-button>
        <b-modal title="Variables" v-model="show">
            <b-list-group>
              <b-list-group-item v-for="v in vars" :key="v.name" @click="varShow(v)">
                <template v-if="v.varName">
                    {{ v.name }} <strong>as</strong> {{ v.varName }}
                </template>

                <template v-else>
                    {{ v.name }}
                </template>
              </b-list-group-item>

              <b-modal :title="varData.name" v-model="varModalShow" hide-footer>
                  <pre style="width: 100%">{{ varUsage() }}</pre>
              </b-modal>
            </b-list-group>
        </b-modal>
    </div>
</template>

<style scoped>
pre {
    white-space: pre-wrap;       /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;  
}
</style>

<script>
import {parse, stringify} from 'comment-json'

export default {
    name: "Vars",
    props: {
        vars: {
            type: Array
        }
    },
    data: function() {
        return {
            show: false,
            varModalShow: false,
            varData: {}
        }
    },
    methods: {
        varShow(data) {
            this.varModalShow = true
            this.varData = data
            this.$emit("controlAction", "vars", this.varData)
        },

        varUsage() {
            let usage = this.varData.usage || null

            try {
                return stringify(parse(usage), null, 4)
            } catch (error) {
                return this.varData.usage
            }
            
        }
    },
}
</script>